import styled from 'styled-components';
import { PALETTE_COLORS, SEMANTIC_COLORS } from '@/constant/unit/color';
export const S = {
    CardBody: styled.div `
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    width: 100%;
    height: auto;
    min-height: 105px;
    margin-bottom: 10px;
    cursor: ${(props) => (props.isReadOnly ? 'default' : 'pointer')};
  `,
    CardBodyLeft: styled.div `
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 12px 18px;

    background: ${SEMANTIC_COLORS.PRIMARY_CARD_BACKGROUND};
    border: ${(props) => props.isChecked
        ? `3px solid ${SEMANTIC_COLORS.PRIMARY_BORDER}`
        : `3px solid ${SEMANTIC_COLORS.PRIMARY_CARD_BACKGROUND}`};
    border-right: none;
    border-radius: 10px 0 0 10px;
  `,
    CardBodyLeftTitle: styled.div `
    margin: 0 34px 10px 0;
    font-size: 20px;
    font-weight: 500;
    line-height: 29px;
    color: ${SEMANTIC_COLORS.PRIMARY_TEXT};
  `,
    CardBodyLeftText: styled.div `
    margin-right: 34px;
    font-size: 18px;
    line-height: 26px;
    color: ${SEMANTIC_COLORS.DEFAULT_TEXT};
  `,
    CardBodyCheck: styled.div `
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 52px;

    background: ${PALETTE_COLORS.PRIMARY_500};
    border: 3px solid ${SEMANTIC_COLORS.PRIMARY_BORDER};
    border-radius: 0 10px 10px 0;
    opacity: ${(props) => (props.isChecked ? 1 : 0.2)};
  `,
};
